import React from "react";
import { CONTACT } from "@/data/classes";
import Seo from "@/components/Seo";

export default function Policies() {
  return (
    <div>
      <Seo
        title="Policies"
        path="/policies"
        description="Cancellation, refunds, attendance, payment, and privacy policies for Rhythm Check Training classes."
      />
      <section className="bg-white border-b border-gray-200">
        <div className="max-w-4xl mx-auto px-6 lg:px-10 py-16">
          <div className="font-mono-label text-[#d90429] mb-4">Policies</div>
          <h1 className="font-display text-5xl md:text-6xl font-black text-[#0a0a0a] leading-none">
            Clear terms. No surprises.
          </h1>
        </div>
      </section>
      <section className="bg-[#f9fafb] py-16">
        <div className="max-w-4xl mx-auto px-6 lg:px-10 space-y-10">
          <PolicyBlock
            title="Cancellation & Refunds"
            body={[
              "Full refunds are available up to 48 hours before class start.",
              "Cancellations within 48 hours receive credit toward a future class.",
              "No-shows are non-refundable.",
              "We reserve the right to reschedule for inclement weather or instructor emergencies — you'll be offered a new date or full refund.",
            ]}
          />
          <PolicyBlock
            title="Attendance"
            body={[
              "Please arrive 10 minutes early. Late arrivals may not be admitted.",
              "Full attendance and successful skills evaluation are required to receive certification.",
              "Dress comfortably — you'll be on the floor practicing CPR.",
            ]}
          />
          <PolicyBlock
            title="Payment"
            body={[
              "Payment for open enrollment classes is collected on-site (cash, card, or approved method).",
              "Group and workplace bookings are invoiced according to the agreement.",
            ]}
          />
          <PolicyBlock
            title="Privacy"
            body={[
              "We collect only the information needed to register you for a class and issue certification.",
              "We do not sell or share your contact information.",
              "Contact us at " + CONTACT.email + " to request removal of your data.",
            ]}
          />
        </div>
      </section>
    </div>
  );
}

function PolicyBlock({ title, body }) {
  return (
    <div className="bg-white border border-gray-200 rounded-lg p-8">
      <h2 className="font-display text-2xl md:text-3xl font-black text-[#0a0a0a]">{title}</h2>
      <ul className="mt-5 space-y-2 text-gray-700 list-disc pl-6">
        {body.map((b, i) => (
          <li key={i}>{b}</li>
        ))}
      </ul>
    </div>
  );
}
